<template>
  <div id="app">
    <Nav />
    <Header class="header" @openForm="openForm" />
    <HeaderM class="headerM" @openForm="openForm" />
    <router-view  @openForm="openForm"/>
    <Footer />
    <ModalForm v-show="isViewModal == true" @closeForm="closeForm"/>
  </div>
</template>


<script>
import Header from '@/components/Header'
import HeaderM from '@/components/mobile/HeaderM'

import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import ModalForm from '@/components/ModalForm'

export default {
  name: 'App',
  data() {
    return {
      isViewModal: false,
    };
  },
  components: {
     Header,
     Nav, Footer, ModalForm, HeaderM
  },
  methods: {
    closeForm() {
      this.isViewModal = false
    },
    openForm() {
      this.isViewModal = true
    },
  },
}
</script>

<style lang="less">
@baseMedia: 900px;
body {
  background: url('assets/meshok.jpg') repeat;
  background-attachment: fixed;
}
* {
  margin: 0;
  padding: 0;
  font-family: calibri;
}
.header {
  display: block;
  @media (max-width: @baseMedia) {
      display: none;
  }
}
.headerM {
  display: none;
  @media (max-width: @baseMedia) {
      display: block;
  }
}

</style>
